import React from "react"
import { Link } from "gatsby"

const MainNav = ({variant}) => (
  <>
    <div className={`main-nav main-nav-${variant} not-mobile`}>
        <ul>
            <li><Link to="/our-services/">Our Services</Link></li>
            <li><Link to="/case-studies/">Work</Link></li>
            <li><Link to="/the-team/">Who We Are</Link></li>
            <li><Link to="/latest-news/">News</Link></li>
            <li><Link to="/about/">About</Link></li>
            <li><Link to="/contact/">Contact</Link></li>
        </ul>
    </div>
  </>
)

export default MainNav
